import { ApplicationState, VerificationStepConfigState } from "@idw-types/state";
import { createSelector } from "reselect";

export const getVerificationStepConfigState = (state: ApplicationState): VerificationStepConfigState => {
    return state.verificationStepConfig;
};

export const getVerificationStepConfig = createSelector(getVerificationStepConfigState, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig;
});

export const getIsStartingCapture = createSelector(getVerificationStepConfigState, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.isStartingCapture;
});

export const getCaptureStarted = createSelector(getVerificationStepConfigState, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.captureStarted;
});

export const getCaptureSteps = createSelector(getVerificationStepConfigState, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.captureSteps;
});

export const getCaptureMode = createSelector(getVerificationStepConfig, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.captureMode;
});

export const getResponseToken = createSelector(getVerificationStepConfig, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.responseToken || null;
});

export const getSharpnessFailureCount = createSelector(getVerificationStepConfig, (verificationStepConfig: VerificationStepConfigState) => {
    return verificationStepConfig.sharpnessFailureCount;
});